import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OutlookComposeEmailComponent } from '../outlook-compose-email/outlook-compose-email.component';
import { ImagilityComposeEmailComponent } from './imagility-compose-email/imagility-compose-email.component';
import { EmailClientService } from '../service/email-client.service';
import { AttorneyProfileService } from 'src/app/services/attorney-profile.service';
import { error } from 'console';


@Component({
  selector: 'app-unified-email-component',
  templateUrl: './unified-email-component.component.html',
  styleUrls: ['./unified-email-component.component.scss']
})
export class UnifiedEmailComponentComponent implements OnInit {
  
  currentSelected:string = 'INBOX';
  userId:any = sessionStorage.getItem('userId');
  companyId:any = sessionStorage.getItem('companyId');
  userType:any = sessionStorage.getItem('userTypeRole');
  deleteIds:any=[];
  emailDropdown:boolean = false;

  @Input() inboxdata: any = [];
  moreToggle:boolean = false;
  searchText:string = '';
  emailCounts:any;

  constructor(private modalservice: NgbModal, private emailClientService: EmailClientService, private attorService: AttorneyProfileService) { }

  ngOnInit(): void {
    this.mailFunc(this.currentSelected);
    this.getUnifiedEmail(this.currentSelected);
    this.getEmailCounts();
  }

  changeClass(data, index){
    
    data.dropdown =! data.dropdown;
    if(data.dropdown){
      (<HTMLInputElement>document.getElementById(index)).style.height = '90px';
    }
    else{
      (<HTMLInputElement>document.getElementById(index)).style.height = '45px';
    }
  }

  mailFunc(type){
    
    this.searchText = "";
    this.currentSelected = type; 
    this.getUnifiedEmail(this.currentSelected);
  }

  moreToggleFunc(){
    this.moreToggle =! this.moreToggle;
  }

  getEmailCounts(){    
    this.attorService.getEmailCounts(this.userId).subscribe(result => {
      this.emailCounts = result.data.response;
    }, error => {
      alert('error');
      this.deleteIds = [];

    })
  }


  selectDeselectAll(event){
    this.deleteIds = [];
    if(event.target.checked){
      for(let i=0; i<this.inboxdata.length; i++){
        this.inboxdata[i].ischecked = true;

        for(let j = 0; j< this.inboxdata[i]?.emailsList?.length; j++ ){
          this.inboxdata[i].emailsList[j].ischecked = true;
          this.deleteIds.push( this.inboxdata[i].emailsList[j].id);
        }
      }      
    }
    else{
      this.deleteIds = [];
      for(let i=0; i<this.inboxdata.length; i++){
        this.inboxdata[i].ischecked = false;

        for(let j = 0; j< this.inboxdata[i]?.emailsList?.length; j++ ){
          this.inboxdata[i].emailsList[j].ischecked = false;
        }
      } 
    }
  }


  singleSelectCheckbox(event, data){
    
    if(event.target.checked){
      this.deleteIds.push(data.id);
    }
    else{
      let getIndx = this.deleteIds.map(item => {
        return item.id;
      }).indexOf(data.id)
      
      this.deleteIds.splice(getIndx, 1);
    }
  }

  deleteEmail(){
    if(this.deleteIds.length == 0){
      return
    }
    var obj = {
      loginId:Number(this.userId), 
      folder: 'DELETE',
      threadIds: this.deleteIds
    }

    let body = "";
     
    this.attorService.deleteUnifiedEmail(obj, body).subscribe(result => {
      this.deleteIds = [];
      this.getUnifiedEmail(this.currentSelected);
    }, error => {
      alert('error');
      this.deleteIds = [];

    })
  }


  

  composeEmail(mode, data){
    let modalRef = this.modalservice.open(ImagilityComposeEmailComponent, {
      backdrop:'static', size: 'xl'
    })
    
    modalRef.componentInstance.unifiedTaskId = 0;

    if(mode == 'edit'){
      
      modalRef.componentInstance.isUnified = true;
      modalRef.componentInstance.emailData = data;
    }
    else{
      modalRef.componentInstance.emailData = null;
    }  

    modalRef.componentInstance.currentSelected = this.currentSelected;

    if(mode == 'new'){
      modalRef.componentInstance.currentSelected = 'Compose';
    }

    modalRef.result.then(res => {
      if(res.data != null){ 
        console.log('Hello Email Recd');
        this.mailFunc(this.currentSelected);
        this.getUnifiedEmail(this.currentSelected);
        this.getEmailCounts();
      }
    })
  }


  getUnifiedEmail(folder){    
    let body = {
      "pageNumber": 1,
      "pageSize": 10,
      "searchText": this.searchText
    }
    this.attorService.getUnifiedEmail(Number(this.companyId), Number(this.userId), 0, folder, body).subscribe(result => {
      this.inboxdata = result.data.emails;
    }, (error:any) => {
      this.inboxdata = [];
    })
  }


  searchEmail(event){
    
    this.searchText = event;
    this.getUnifiedEmail(this.currentSelected);
  }

}
